// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__1Cyg0","modalBody":"MealsPop_modalBody__6q5m6"};